// Sales Access — invitation-only and controlled sales (docs/SALES-ACCESS.md): every sale, filtered in the
// query. The screens are the contractor's design (src/modules/venue-port/features/sales-access), routed by
// tkt/SalesAccessRoutes.jsx. A real file route: its own chunk, nothing added to the legacy $.tsx switch.
import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SalesAccessLandingRoute } from '../modules/venue-port/tkt/SalesAccessRoutes';

export const Route = createFileRoute('/sales-access/')({
  component: () => <SalesAccessLandingRoute />,
});
